import { SunOutlined , MoonOutlined} from '@ant-design/icons'
import { useThemeMode } from '@/theme/ThemeContext'
import UserMenu from './UserMenu'

export default function ComponentHeader() {
    const { isDarkMode, toggleTheme } = useThemeMode()

    return (
        <div className="layout-header">
            <div className="layout-header-container max-w-8xl min-w-1024 min-header-w-1024 mx-auto">
                <div className="layout-header-content">
                    <img src="/favicon.svg" alt="logo" style={{ width: '20px', height: '20px', marginRight: '8px' }} />
                    <b className="layout-header-desc">Novus</b>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <UserMenu />
                    <div
                        className="layout-header-right"
                        onClick={toggleTheme}
                        role="button"
                        tabIndex={0}
                        aria-label={isDarkMode ? '切换到浅色模式' : '切换到深色模式'}
                        onKeyDown={e => e.key === 'Enter' && toggleTheme()}
                    >
                        {
                            isDarkMode ? <SunOutlined style={{ color: 'var(--base-color-text)' }} /> : <MoonOutlined style={{ color: 'var(--base-color-text)' }} />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
